import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLessons, getUnassignedLessons } from '../redux/actions/lessons';
import { getPaginatedStudents, getPaginatedTeachers, getStudentsByIds, getTeachersByIds } from '../api/users';

import {
    Button,
    Typography,
    TextField,
    FormControl,
    Autocomplete,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material"
import { makeStyles } from "@mui/styles";

import $ from 'jquery';
import eventEmitter from '../event/EventEmitter'
import { deleteAjax, putAjax, getToken } from '../auth/ApiAuth'

import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    CancelButton: {
        backgroundColor: '#AA1111',
        '&:hover': {
            backgroundColor: "#CC1111",
        },
        color: "#fff"
    },
    inputForm: {
        marginTop: '10px',
    }
}));

function DialogEvent(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [isConfirmBox, setConfirmBox] = useState(false)
    const [description, setDescription] = useState()
    const [eventDuration, setEventDuration] = useState()

    // for submit
    const [selectedDriver, setSelectedDriver] = useState()
    const [selectedTeacher, setSelectedTeacher] = useState()
    const [selectedRoute, setSelectedRoute] = useState()
    const [selectedPoint, setSelectedPoint] = useState()

    // for autocomplete
    const [routeList, setRouteList] = useState([])
    const [pointList, setPointList] = useState([])

    // selectors
    const [driverQuery, setDriverQuery] = useState('')
    const [driverLoading, setDriverLoading] = useState(false)
    const [driverOptions, setDriverOptions] = useState([])
    const [driverValue, setDriverValue] = useState(null)

    const [teacherQuery, setTeacherQuery] = useState('')
    const [teacherLoading, setTeacherLoading] = useState(false)
    const [teacherOptions, setTeacherOptions] = useState([])
    const [teacherValue, setTeacherValue] = useState(null)
    const routes = useSelector(state => state.map.Routes)
    const points = useSelector(state => state.map.Points)

    const isLessonReserved = (
        props.defaultValues.isExist 
        && props.permission === 'student' 
        && props.defaultValues.driverFullName !== "Brak"
    )

    useEffect(()=>{
        setEventDuration(moment(props.defaultValues.start).format("HH:mm") + " - " + moment(props.defaultValues.end).format("HH:mm"))

        setSelectedDriver(props.defaultValues.driver)
        setSelectedTeacher(props.defaultValues.teacher)
        setSelectedRoute(props.defaultValues.route)
        setSelectedPoint(props.defaultValues.startPoint)
        setDescription(props.defaultValues.description)
    },[props])

    useEffect(() => {
        const setDriverFromId = async (id) => {
            if (!id) { setDriverValue(null); return }
            try {
                const resp = await getStudentsByIds([id])
                const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : [])
                const u = list[0]
                if (u) setDriverValue({ id: u.pk, label: `${u.first_name} ${u.last_name} (${u.email})` })
            } catch (_) {}
        }
        const setTeacherFromId = async (id) => {
            if (!id) { setTeacherValue(null); return }
            try {
                const resp = await getTeachersByIds([id])
                const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : [])
                const u = list[0]
                if (u) setTeacherValue({ id: u.pk, label: `${u.first_name} ${u.last_name} (${u.email})` })
            } catch (_) {}
        }
        setDriverFromId(props.defaultValues.driver)
        setTeacherFromId(props.defaultValues.teacher)
    }, [props.defaultValues.driver, props.defaultValues.teacher])

    useEffect(()=>{
        setRouteList(getRoutes())
        // eslint-disable-next-line
    },[routes])

    useEffect(()=>{
        setPointList(getPoints())
        // eslint-disable-next-line
    },[points])

    useEffect(() => {
        const handler = setTimeout(async () => {
            console.log(driverQuery)
            const q = driverQuery.trim()
            if (q.length === 0) { setDriverOptions([]); setDriverLoading(false); return }
            setDriverLoading(true)
            try {
                const params = q.includes(' ')
                    ? { name: q, is_active: true }
                    : { search: q, is_active: true }
                const resp = await getPaginatedStudents(params)
                const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : [])
                const opts = list.map(u => ({ id: u.pk, label: `${u.first_name} ${u.last_name} (${u.email})` }))
                setDriverOptions(opts)
            } finally { setDriverLoading(false) }
        }, 300)
        return () => clearTimeout(handler)
    }, [driverQuery])

    useEffect(() => {
        const handler = setTimeout(async () => {
            const q = teacherQuery.trim()
            if (q.length === 0) { setTeacherOptions([]); setTeacherLoading(false); return }
            setTeacherLoading(true)
            try {
                const params = q.includes(' ')
                    ? { name: q, is_active: true }
                    : { search: q, is_active: true }
                const resp = await getPaginatedTeachers(params)
                const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : [])
                const opts = list.map(u => ({ id: u.pk, label: `${u.first_name} ${u.last_name} (${u.email})` }))
                setTeacherOptions(opts)
            } finally { setTeacherLoading(false) }
        }, 300)
        return () => clearTimeout(handler)
    }, [teacherQuery])

    function getRoutes() {
        let options = []
        for (let route of routes) {
            if ((route['createdBy'] === Number(localStorage.getItem('userPK')) || route['createdByAdmin']) && !route['isArchived'])
            {
                options.push({ label: route['title'], id: route['pk'] });
            }
        }
        return options
    }

    function getPoints(){
        let options = []
        for (let point of points) {
            options.push({ label: point['description'], id: point['pk'] })
        }
        return options
    }


    const handleDescriptionFieldChange = (e) => {
        if(e.target.value.length>200)
            eventEmitter.emit('popupAlert', ['Zbyt długi ciąg znaków!', 'error'])
        else
            setDescription(e.target.value)
    }

    const deleteButton = (
        <Box sx={{ mr: 'auto' }}>
            <Button
                variant="contained"
                color="error"
                className={classes.CancelButton}
                onClick={() => { handleCancel() }}
            >
                <Typography variant="button">Odwołaj lekcję</Typography>
            </Button>
        </Box>
    );

    // const cancelButton = (
    //     <Box sx={{ mr: 'auto' }}>
    //         <Button
    //             variant="contained"
    //             color="error"
    //             className={classes.CancelButton}
    //             onClick={() => { handleCancel() }}
    //         >
    //             <Typography variant="button">Anuluj rezewację</Typography>
    //         </Button>
    //     </Box>
    // );

    function handleCancel() {
        setConfirmBox(true);
    }

    async function handleCancelLesson() {
        let baseurl = `${process.env.REACT_APP_BASE_URL}/api/lessons/` + props.defaultValues.id + '/'
        let data = {
            teacher: props.defaultValues.teacher,
            driver: null,
        }
        await putAjax(baseurl, data);

        refreshLessons();

        setConfirmBox(false);

        props.onClose()
    }

    async function handleDelete() {
        let baseurl = `${process.env.REACT_APP_BASE_URL}/api/lessons/` + props.defaultValues.id + '/'
        await deleteAjax(baseurl)

        refreshLessons();

        setConfirmBox(false);

        props.onClose()
    }

    async function handleSubmit() {
        let data = {
            'start': moment(props.defaultValues.start).format('YYYY-MM-DD HH:mm'),
            'end': moment(props.defaultValues.end).format('YYYY-MM-DD HH:mm'),
            'driver': selectedDriver,
            'teacher': selectedTeacher,
            'route': selectedRoute,
            'startPoint': selectedPoint,
            'description': description,
        }

        if (data['teacher'] === null){
            eventEmitter.emit('popupAlert', ['Nie podano instruktora!', 'error'])
            return
        }

        let baseurl;
        let method;
        if (props.defaultValues.isExist) {
            baseurl = `${process.env.REACT_APP_BASE_URL}/api/lessons/` + props.defaultValues.id + '/'
            method = 'PUT'
        } else {
            baseurl = `${process.env.REACT_APP_BASE_URL}/api/lessons/`
            method = 'POST'
        }

        $.ajax({
            url: baseurl,
            type: method,
            data: data,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': method,
                'Access-Control-Allow-Headers': 'application/json',
                'Authorization': 'Token ' + getToken(),
            },
            success: function() {
                eventEmitter.emit('popupAlert', ['Operacja przebiegła pomyślnie!', 'success'])
                refreshLessons();
                props.onClose()
            },
            error: function(error) {
                if (error && (error.status === 401 || error.status === 403)) {
                    eventEmitter.emit('popupAlert', ['Brak uprawnień lub sesja wygasła', 'error']);
                    return;
                }
                if (error.responseJSON && error.responseJSON.carLimit) {
                    eventEmitter.emit('popupAlert', [error.responseJSON.carLimit[0], 'error']);
                    // Dialog stays open, form values preserved
                } else {
                    eventEmitter.emit('popupAlert', ['Błąd operacji spróbuj ponownie!', 'error']);
                    props.onClose();
                }
            }
        });
    }

    const refreshLessons = useCallback(() => {
        const activeFilter = localStorage.getItem('activeFilter');
        const filterValue = (activeFilter === 'null' || activeFilter === null)
            ? null
            : parseInt(activeFilter);

        if (props.permission === 'student') {
            dispatch(getUnassignedLessons(props.dates[0], props.dates[1], filterValue, { driver: 'me' }));
        } else {
            dispatch(getLessons(props.dates[0], props.dates[1], filterValue));
        }
    }, [props.permission, props.dates, dispatch]);

    function handleOpen() {
        switch (props.permission) {
            case 'teacher':
                if (props.defaultValues.isExist === true && parseInt(localStorage.userPK) !== props.defaultValues.teacher) return false;
                else return props.isOpen;
            case 'student':
                if (props.defaultValues.isExist === false) return false;
                else return props.isOpen;
            case 'admin':
                return props.isOpen;
            default:
                return false;
        }
    }

    return (
        <>
            <Dialog open={handleOpen()} fullWidth>
                <DialogTitle>
                    Utwórz lekcję jazdy
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <DialogContentText>
                            Numer lekcji kursanta:
                        </DialogContentText>

                        <FormControl fullWidth sx={{ mt: 2 }}>

                            {/* duration */}
                            <TextField
                                className={classes.inputForm}
                                label="Godziny"
                                variant="standard"
                                value={eventDuration}
                                fullWidth
                            />

                            {/* teachers */}
                            <Autocomplete
                                disablePortal
                                className={classes.inputForm}
                                options={teacherOptions}
                                filterOptions={(x) => x}
                                loading={teacherLoading}
                                openOnFocus
                                noOptionsText={teacherQuery.trim() ? 'Brak wyników' : 'Zacznij wpisywać, aby wyszukać'}
                                value={teacherValue}
                                onChange={(event, value) => {
                                    setTeacherValue(value)
                                    setSelectedTeacher(value === null ? null : value.id)
                                }}
                                onInputChange={(e, value) => { setTeacherOptions([]); setTeacherQuery(value); }}
                                disabled={props.permission === 'admin' ? false : true}
                                fullwidth
                                renderInput={(params) => <TextField {...params} variant="standard" label="Instruktor" />}
                            />

                            {/* drivers (async search) */}
                            <Autocomplete
                                disablePortal
                                className={classes.inputForm}
                                options={driverOptions}
                                filterOptions={(x) => x}
                                loading={driverLoading}
                                openOnFocus
                                noOptionsText={driverQuery.trim() ? 'Brak wyników' : 'Zacznij pisać, aby wyszukać'}
                                value={driverValue}
                                onChange={(event, value) => {
                                    setDriverValue(value)
                                    setSelectedDriver(value === null ? null : value.id)
                                }}
                                onInputChange={(e, value) => { setDriverOptions([]); setDriverQuery(value); }}
                                disabled={props.permission === 'student' ? true : false}
                                fullwidth
                                renderInput={(params) => <TextField {...params} variant="standard" label="Kursant" />}
                            />

                            {/* routes */}
                            <Autocomplete
                                disablePortal
                                className={classes.inputForm}
                                options={routeList}
                                onChange={(event, value) => {
                                    setSelectedRoute(value === null ? null : value.id)
                                }}
                                disabled={props.permission === 'student' ? true : false}
                                // eslint-disable-next-line
                                defaultValue={routeList.filter( (route) => { return route['id'] == props.defaultValues.route ? true : false })[0]}
                                fullwidth
                                renderInput={(params) => <TextField {...params} variant="standard" label="Domyślna trasa" />}
                            />

                            {/* points */}
                            <Autocomplete
                                disablePortal
                                className={classes.inputForm}
                                options={pointList}
                                onChange={(event, value) => {
                                    setSelectedPoint(value === null ? null : value.id)
                                }}
                                disabled={props.permission === 'student' ? true : false}
                                // eslint-disable-next-line
                                defaultValue={pointList.filter( (point) => { return point['id'] == props.defaultValues.startPoint ? true : false })[0]}
                                fullwidth
                                renderInput={(params) => <TextField {...params} variant="standard" label="Punkt startowy" />}
                            />

                            {/* description */}
                            <TextField
                                value={description}
                                sx={{mb: 2}}
                                className={classes.inputForm}
                                onChange={handleDescriptionFieldChange}
                                label="Opis"
                                variant="standard"
                                fullWidth
                            />

                        </FormControl>

                        <DialogActions style={{ display:'felx', justifyContent: isLessonReserved ? 'space-between' : 'flex-end' , width:'100%' }}>
                            {props.defaultValues.isExist && ['admin', 'teacher'].includes(props.permission) ? deleteButton : ''}
                            {isLessonReserved ? 
                            <Box style={{justifyContent:'flex-start'}}>
                                <Typography style={{fontSize:13}}>
                                    TWOJA ZAREZERWOWANA LEKCJA
                                </Typography>  
                                <Typography style={{fontSize:12}}>
                                    Aby ją odwołać skontaktuj się z administratorem.
                                </Typography>  
                            </Box>
                            : ''}
                            <Box>
                                <Button
                                    color="error"
                                    onClick={() => {
                                        props.onClose()
                                    }}
                                    style={{
                                        alignSelf:'flex-end'
                                    }}
                                >
                                    <Typography sx={{ color: 'red' }} variant="button">Anuluj</Typography>
                                </Button>
                                <Button onClick={() => handleSubmit()}>
                                <Typography variant="button">
                                    {props.permission === 'student' ? "REZERWUJ" : "ZAPISZ"}
                                </Typography>
                            </Button>
                            </Box>
                        </DialogActions>

                    </form>
                </DialogContent>
            </Dialog>

            <Dialog open={isConfirmBox}>
                <DialogTitle>Odwołaj lekcję jazdy</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {props.permission !== 'student' ?
                            'Czy na pewno chcesz odwołać tą lekcję? To działanie jest nieodwracalne.' :
                            'Czy na pewno chcesz odwołać tą rezerwację?'
                        }
                    </DialogContentText>
                    <DialogActions sx={{ mt: 2 }}>
                        <Button onClick={() => { setConfirmBox(false); }}>
                            <Typography variant="button">Anuluj</Typography>
                        </Button>
                        <Button onClick={() => {
                            props.permission !== 'student' ? handleDelete() : handleCancelLesson();
                        }}>
                            <Typography sx={{ color: 'red' }} variant="button">TAK</Typography>
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default DialogEvent
